/**
 * Container for Transport Trip Details
 */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { CircularProgress, Grid, TextField, Box, Button, Alert, Typography} from "@mui/material";
import moment from "moment";
import WeekPicker from "pages/Timesheet/WeekPicker";
import { timeConfig, dateConfig, SET_EMPTY } from "config";
import { date, time, getTransportPunchesData } from "utils/report";
import { MY_TEAM, OTHER_TEAM } from "config/CONSTANTS";
import { useLocation, useHistory } from "react-router-dom";
import ConfirmDialog from "components/ConfirmDialog";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Link } from "react-router-dom";
import { styled } from "@mui/styles";
import {
  createMuiTheme,
  makeStyles,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import { INCOMPLETE_BG_INVALID, INCOMPLETE_BG_VALID } from "config";
import { Card } from "@material-ui/core";
import { properCase } from "utils";
import { useDispatch } from "react-redux";
import {
  saveTransportDetailsFilterList,
  selectedWeekOnReview,
} from "redux/actions/appActions";
import {
  defaultPaginationOptions,
  defaultRowsPerPage,
  getTextLabels,
  DURATION_GT_12,
  AUTO_ADJUST_TRIP_MILEAGE,
  AUTO_CLOCK_OUT_TIME_DIFF,
} from "../../../config/index";
import { endOfWeek, startOfWeek } from "date-fns";
import Seperator from "components/Seperator";
import TransportDetailsModal from "../components/TransportDetailsModal";
import { object } from "yup";
import { updateTripPunch, deleteTripPunch } from "../../../services";
import Confirmation from "components/Confirmation";
import NoData from "utils/NoData";

export const TransportTripDetails = (props) => {
  const location = useLocation();
  const classes = useStyles();

  const history = useHistory();
  const locationProps = location.state;
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(SET_EMPTY);
  const [data, setData] = useState([]);
  const { appConfig } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { transportDetalisFiltersData } = useSelector(
    (state) => state.appConfig
  );
  const { approveForManager, selectedTeam, imtRole } = props;
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  const [startDate, setStartDate] = React.useState(
    appConfig.selectedWeekOnReview
      ? appConfig.selectedWeekOnReview.week
      : new Date()
  );
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedTripPunch, setSelectedTripPunch] = useState({});
  const [refreshData, setRefreshData] = useState(false);
  const [confirmDialogDel, setConfirmDialogDel] = useState({
    isOpen: false,
    title: "other.tlConfirmation",
    subTitle: "pgReview.deleteWorkersDialog.subTitle",
  });
  const [confirmationBox, setConfirmationBox] = useState({
    isOpen: false,
    title: t("pgPunch.tlConfirmation"),
    subTitle: t("pgReview.dialogueMsgs.msgSuccess"),
  });

  const [tripEditable, setTripEditable] = useState(true);
  const [selectedTransDetails, setSelectedTransDetails] = useState([]);
  const [disableDeleteBtn, setDisableDeleteBtn] = useState(true);
  const blank = properCase(t("pgReview.tableStaticText.blank"));

  useEffect(() => {
    setIsLoading(true);
    setLoadingError(SET_EMPTY);
    if (user.workerId && !userLoading) {
      let date = startDate ? new Date(startDate) : new Date();
      console.log("startDate", startDate);
      date = date.setHours(0, 0, 0, 0);
      let userWorkerId =
        selectedTeam === OTHER_TEAM
          ? approveForManager.managerId
          : user.workerId;
      getTransportPunchesData(
        userWorkerId,
        moment(startOfWeek(date)).format(dateConfig.format4),
        moment(endOfWeek(date)).format(dateConfig.format4)
      )
        .then((data) => {
          if (data && data.length > 0) {
            let filterData = data.filter(
              (ele) =>
                (ele.inTrip === true && !ele.outLocalTS) || ele.inTrip === false
            );
            console.log("data", data, filterData);
            if (selectedTeam === OTHER_TEAM) {
              let delegateFor = user?.delegateFor;
              if (
                !(
                  delegateFor &&
                  approveForManager &&
                  delegateFor.includes(approveForManager.managerId)
                ) &&
                ((imtRole &&
                  imtRole !== "" &&
                  imtRole.toLowerCase() === "supervisor") ||
                  (!imtRole && user.isApprover))
              ) {
                filterData = filterData.filter(
                  (item) =>
                    item.worker &&
                    item.worker.approvingManager &&
                    item.worker.approvingManager.includes(user.workerId)
                );
              }
            }

            // data = filterData.filter((item) => {
            //   return (
            //     moment(item.outTS).isSameOrBefore(
            //       moment(endOfWeek(date)),
            //       "day"
            //     ) &&
            //     moment(item.outTS).isSameOrAfter(
            //       moment(startOfWeek(date)),
            //       "day"
            //     )
            //   );
            // });
            //data = udpatePunchStatus(data);
            console.log("Transport Trip data:", data);
            setData(filterData);
            setLoadingError(SET_EMPTY);
          } else {
            setLoadingError("pgReview.noPunchesToReport");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setLoadingError("pgReview.errLoadingWorkerList");
          console.error(
            "TransportTripDetails: Err in getWorkerByMgr Response: ",
            err
          );
        });
    } else if (userLoading) {
      console.log("Continue loading google user's data from IRM DB!");
    } else {
      setIsLoading(false);
      setLoadingError("pgReview.errLoadingWorkerId");
      console.log(
        "TransportTripDetails: else in getWorkerByMgr condition: No Logged in worker details found!"
      );
    }
  }, [userLoading, startDate, refreshData, approveForManager, selectedTeam]);

  useEffect(() => {
    console.log("location props inside punch", locationProps);
    if (
      locationProps &&
      locationProps.punch &&
      appConfig.selectedWeekOnReview?.week &&
      data.length > 0
    ) {
      let rowData = data.filter(
        (item) => item.punchId == locationProps.punch.id
      );
      if (rowData.length > 0) {
        setSelectedTripPunch(rowData[0]);
        setOpenEditModal(true);
      }
    }
  }, [locationProps, data]);

  useEffect(() => {
    if (startDate) {
      let today = moment().startOf("day");
      let createdDate = moment(startDate, "YYYY-MM-DD").startOf("day");
      let diff = today.diff(createdDate, "days");

      if (diff >= 21) {
        setTripEditable(false);
      } else {
        setTripEditable(true);
      }
    }
  }, [startDate]);

  const weekChangeHandler = (date) => {
    console.log("PunchHeader > WeekPicker value changed===", date);
    //var weekStart = moment(date).format();
    ///console.log("WEEK SELECTION: weekStart: ", weekStart);
    setStartDate(date);
    dispatch(selectedWeekOnReview({ week: date }));
  };

  const onSaveTripDetails = (editedPunch) => {
    console.log("editedPunch", editedPunch, selectedTripPunch);
    if (
      Object.keys(selectedTripPunch).length > 0 &&
      selectedTripPunch.punchId &&
      editedPunch &&
      Object.keys(editedPunch).length > 0
    ) {
      updateTripPunch(selectedTripPunch.punchId, editedPunch)
        .then((result) => {
          setOpenEditModal(false);
          setSelectedTripPunch({});
          setConfirmationBox({
            ...confirmationBox,
            title: t("pgPunch.tlConfirmation"),
            subTitle: t("pgReview.dialogueMsgs.msgSuccess"),
            isOpen: true,
          });
          replaceHistory();
          console.log("Transport trip updated", result);
        })
        .catch((err) => {
          setOpenEditModal(false);
          setConfirmationBox({
            ...confirmationBox,
            title: t("other.tlAddWorkerErrorMsg"),
            subTitle: "",
            isOpen: true,
          });
          console.log("Transport Details update failed", err);
        });
    }
  };

  const updateDone = () => {
    setConfirmationBox({ ...confirmationBox, isOpen: false });
    setRefreshData(!refreshData);
  };

  const TransportDetailsTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: 6,
        },
      },
      MuiIconButton: {
        root: {
          primary: {
            color: "#1B75BC",
          },
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiInputLabel: {
        root: {
          "&$focused": {
            color: "#1B75BC",
          },
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          MuiChecked: {
            "&$checked": {
              color: "#1B75BC",
            },
          },
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#1B75BC",
        },
        "&&:hover": {
          color: "#1B75BC",
        },
      },
      MuiInput: {
        underline: {
          "&&:after": {
            borderBottom: "2px solid #1B75BC",
          },
        },
      },
      MuiChip: {
        outlinedPrimary: {
          color: "#1B75BC",
          border: "1px solid #1B75BC",
        },
        deleteIcon: {
          color: "#1B75BC",
        },
      },
      MUIDataTableToolbar: {
        iconActive: {
          color: "#1B75BC",
        },
        icon: {
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiTypography: {
        body2: {
          color: "#1B75BC",
        },
      },
      MUIDataTableToolbarSelect: {
        deleteIcon: {
          color: "red",
        },
      },
    },
  });

  const columns = [
    {
      accessorKey: "name",
      header: properCase(t("pgReview.tableHeads.name")),
      size: 70,
      Cell: ({ renderedCellValue, row }) => {
        let dataIndex = row.id;
        let rowData = data[dataIndex];
        const link = tripEditable ? (
          <Link
            style={{ textDecoration: "none", cursor: "pointer" }}
            onClick={() => {
              console.log("openEditModal");
              setOpenEditModal(true);
              setSelectedTripPunch(rowData);
            }}
          >
            <Typography variant="body2">{renderedCellValue}</Typography>
          </Link>
        ) : (
          <Typography style={{ fontSize: "0.875rem" }}>
            {renderedCellValue}
          </Typography>
        );
        return link;
      },
    },
    {
      accessorKey: "routeId",
      header: properCase(t("other.routeId")),
      size: 70,
    },
    {
      accessorKey: "startOdometer",
      header: properCase(t("other.startOdometer")),
      size: 70,
    },
    {
      accessorKey: "endOdometer",
      header: properCase(t("other.endOdometer")),
      size: 70,
    },
    {
      // Added to include the formatted start date in the downloaded csv
      header: properCase(t("other.transportStartDate")),
      accessorKey: "tripStartDate",
      size: 70,
    },
    {
      // Added to include the formatted start date in the downloaded csv
      header: properCase(t("other.transportStartTime")),
      accessorKey: "tripStartTime",
      size: 70,
    },
    {
      // Added to include the formatted start date in the downloaded csv
      header: properCase(t("other.transportEndDate")),
      accessorKey: "tripEndDate",
      size: 70,
    },
    {
      // Added to include the formatted start date in the downloaded csv
      header: properCase(t("other.transportEndTime")),
      accessorKey: "tripEndTime",
      size: 70,
    },
    {
      accessorKey: "tripDuration",
      header: properCase(t("other.transportTripDuration")),
      size: 70,
    },
    {
      accessorKey: "tripEdited",
      header: properCase(t("other.tripEdited")),
      size: 70,
    },
    // {
    //   accessorKey: "jobName",
    //   label: properCase(t("pgReview.tableHeads.jobFamily")),
    //   options: {
    //     display:false,
    //     filter: true,
    //     download: false,
    //     filterList: transportDetalisFiltersData[11].length
    //       ? transportDetalisFiltersData[11]
    //       : null,
    //   },
    // },
    // {
    //   accessorKey: "activityGroup",
    //   label: properCase(t("pgReview.tableHeads.activityGroup")),
    //   options: {
    //     display:false,
    //     filter: true,
    //     download: false,
    //     filterList: transportDetalisFiltersData[12].length
    //       ? transportDetalisFiltersData[12]
    //       : null,
    //       customBodyRender: (value) => {
    //         if (value.toUpperCase() === "TRANSACTIONAL")
    //         {
    //          return properCase(t("pgHome.reportlabel2Transcational"))
    //         }
    //         else if (value.toUpperCase() === "PROJECT"){
    //          return  properCase(t("pgHome.reprotlabel3Project"))
    //         }
    //         else if(value.toUpperCase() === "NON-TRANSACTIONAL"){
    //          return properCase(t("pgHome.reportlabel1Non-Transactional"))
    //         }
    //         else if(value.toUpperCase() === "LEAVE"){
    //           return properCase(t("other.lblLeave"))
    //          }
    //          else if(value.toUpperCase() === "MEAL"){
    //           return properCase(t("other.tlMeal"))
    //          }
    //         else if(value.toUpperCase() === "BUILDING MOVES"){
    //           return properCase(t("other.tlbuildingmoves"))
    //          }
    //          else {
    //           return value;
    //         }

    //       },
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.buildingId")),
    //   accessorKey: "buildingId",
    //   options: {
    //     display:false,
    //     filter: true,
    //     download: false,
    //     filterList: transportDetalisFiltersData[13].length
    //       ? transportDetalisFiltersData[13]
    //       : null,
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.projectInfo")),
    //   accessorKey: "jobProjectInfo",
    //   options: {
    //     display:false,
    //     filter: true,
    //     download: false,
    //     viewColumns: true,
    //     filterList: transportDetalisFiltersData[14].length
    //       ? transportDetalisFiltersData[14]
    //       : null,
    //     filterOptions: {
    //       renderValue: (v) => (v !== SET_EMPTY ? v : blank),
    //     },
    //     customFilterListOptions: {
    //       render: (v) => (v !== SET_EMPTY ? v : blank),
    //     },
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.exceptionType")),
    //   name: "exceptionName",
    //   options: {
    //     display:false,
    //     filter: true,
    //     download: false,
    //     filterList: transportDetalisFiltersData[15].length
    //       ? transportDetalisFiltersData[15]
    //       : null,
    //     filterOptions: {
    //       renderValue: (v) =>
    //         v === "no exception" || v === SET_EMPTY ? blank : v,
    //     },
    //     customFilterListOptions: {
    //       render: (v) => (v === "no exception" || v === SET_EMPTY ? blank : v),
    //     },
    //     customBodyRender: (value) => {
    //       if (value.toUpperCase() === "MISSED CLOCK IN")
    //       {
    //         return properCase(t("pgPunch.btnMissedClockedIn"))
    //       }
    //        else if (value.toUpperCase() === "MISSED CLOCK OUT")
    //       {
    //         return properCase(t("pgPunch.btnMissedClockedOut"))

    //       } else {
    //         return value === "no exception" ? SET_EMPTY : value;
    //       }

    //     },
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.startDate")),
    //   name: "inLocalTS",
    //   options: {
    //     display:false,
    //     sort: true,
    //     download: false,
    //     filter: true,
    //     filterList: transportDetalisFiltersData[16].length
    //       ? transportDetalisFiltersData[16]
    //       : null,
    //     customBodyRender: (value) => {
    //       return date(value);
    //     },
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.startTime")),
    //   name: "inLocalTS",
    //   options: {
    //     display:false,
    //     sort: true,
    //     filter: false,
    //     filterList:
    //       transportDetalisFiltersData[17] && transportDetalisFiltersData[17].length
    //         ? transportDetalisFiltersData[17]
    //         : null,
    //     download: false,
    //     customBodyRender: (value) => {
    //       return time(value);
    //     },
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.endDate")),
    //   name: "outLocalTS",
    //   options: {
    //     display: false,
    //     sort: true,
    //     filter: true,
    //     download: false,
    //     filterList:
    //       transportDetalisFiltersData[18] && transportDetalisFiltersData[18].length
    //         ? transportDetalisFiltersData[18]
    //         : null,
    //     customBodyRender: (value) => {
    //       return date(value);
    //     },
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.endTime")),
    //   name: "outLocalTS",
    //   options: {
    //     display: false,
    //     sort: true,
    //     filter: false,
    //     download: false,
    //     filterList:
    //       transportDetalisFiltersData[19] && transportDetalisFiltersData[19].length
    //         ? transportDetalisFiltersData[19]
    //         : null,
    //     //filterList: transportDetalisFiltersData[10].length ? transportDetalisFiltersData[10] : null,
    //     customBodyRender: (value) => {
    //       return time(value);
    //     },
    //   },
    // },
    // {
    //   // Added to include the formatted start date in the downloaded csv
    //   label: properCase(t("pgReview.tableHeads.startDate")),
    //   name: "startDate",
    //   options: {
    //     download: false,
    //     display: false,
    //     filter: false,
    //     viewColumns: false,
    //     filterList:
    //       transportDetalisFiltersData[20] && transportDetalisFiltersData[20].length
    //         ? transportDetalisFiltersData[20]
    //         : null,
    //     //filterList: transportDetalisFiltersData[11].length ? transportDetalisFiltersData[11] : null,
    //   },
    // },
    // {
    //   // Added to include the formatted start time in the downloaded csv
    //   label: properCase(t("pgReview.tableHeads.startTime")),
    //   name: "startTime",
    //   options: {
    //     download: false,
    //     display: false,
    //     filter: false,
    //     viewColumns: false,
    //     filterList:
    //       transportDetalisFiltersData[21] && transportDetalisFiltersData[21].length
    //         ? transportDetalisFiltersData[21]
    //         : null,
    //     //filterList: transportDetalisFiltersData[12].length ? transportDetalisFiltersData[12] : null,
    //   },
    // },
    // {
    //   // Added to include the formatted end date in the downloaded csv
    //   label: properCase(t("pgReview.tableHeads.endDate")),
    //   name: "endDate",
    //   options: {
    //     download: false,
    //     display: false,
    //     filter: false,
    //     viewColumns: false,
    //     filterList:
    //       transportDetalisFiltersData[22] && transportDetalisFiltersData[22].length
    //         ? transportDetalisFiltersData[22]
    //         : null,
    //     //filterList: transportDetalisFiltersData[13].length ? transportDetalisFiltersData[13] : null,
    //   },
    // },
    // {
    //   // Added to include the formatted end time in the downloaded csv
    //   label: properCase(t("pgReview.tableHeads.endTime")),
    //   name: "endTime",
    //   options: {
    //     download: false,
    //     display: false,
    //     filter: false,
    //     viewColumns: false,
    //     filterList:
    //       transportDetalisFiltersData[23] && transportDetalisFiltersData[23].length
    //         ? transportDetalisFiltersData[23]
    //         : null,
    //     //filterList: transportDetalisFiltersData[14].length ? transportDetalisFiltersData[14] : null,
    //   },
    // },
    // {
    //   label: properCase(t("pgReview.tableHeads.duration")),
    //   name: "duration",
    //   options: {
    //     display: false,
    //     filter: false,
    //     download: false,
    //     filterList:
    //       transportDetalisFiltersData[24] && transportDetalisFiltersData[24].length
    //         ? transportDetalisFiltersData[24]
    //         : null,
    //     //filterList: transportDetalisFiltersData[15].length ? transportDetalisFiltersData[15] : null,
    //   },
    // },
  ];

  let totalDurationRef = useRef();
  let totalActivityRef = useRef();
  let totalMealRef = useRef();
  let totalTripDurationRef = useRef();
  let indexArray = [];
  let mealArray = [];
  let actArray = [];
  let tripArray = [];
  let Tot = 0;
  let mealTotal = 0;
  let actTotal = 0;
  let tripTotal = 0;

  const onRowSelectionChange = (currentRows, allRows, rowsSelected) => {
    console.log(
      "currentRows, allRows, rowsSelected",
      currentRows,
      allRows,
      rowsSelected
    );
    if (rowsSelected.length > 0) {
      let selctedRowsData = data.filter((_, ind) => rowsSelected.includes(ind));
      console.log("selctedRowsData11", selctedRowsData);
      setSelectedTransDetails(selctedRowsData);
      setDisableDeleteBtn(false);
    } else {
      // console("else");
      setSelectedTransDetails([]);
      setDisableDeleteBtn(true);
    }
  };

  // const options = {
  //   filter: true,
  //   download: false,

  //   viewColumns: false,
  //   filterType: "multiselect",
  //   responsive: "standard",
  //   selectableRows: "multiple",
  //   onFilterChange: (columnChanged, filterList) => {
  //     //console.log("---filterList----",filterList);
  //     //console.log("----columnChanged-----",columnChanged);
  //     dispatch(saveTransportDetailsFilterList(filterList));
  //   },
  //   onRowSelectionChange,
  //   setFilterChipProps: (colIndex, colName, data) => {
  //     console.log(colIndex, colName, data);
  //     return {
  //       style: { color: "#1B75BC", border: "1px solid #1B75BC" },
  //       variant: "outlined",
  //       className: "testClass123",
  //     };
  //   },
  //   onTableChange: (action, tableState) => {
  //     indexArray = [];
  //     mealArray = [];
  //     actArray = [];
  //     tripArray = [];
  //   },

  //   // apply background color to rows with incomplete status
  //   // setRowProps: (row, dataIndex, rowIndex) => {
  //   //   const bgWithinRange = INCOMPLETE_BG_VALID;
  //   //   const bgOutOfRange = INCOMPLETE_BG_INVALID;
  //   //   if (data[dataIndex]) {
  //   //     let tempTot = parseFloat(parseFloat(data[dataIndex].duration) + Tot);
  //   //     let tempTripDurTot = data[dataIndex].tripDuration
  //   //       ? parseFloat(parseFloat(data[dataIndex].tripDuration) + tripTotal)
  //   //       : tripTotal;
  //   //     if (data[dataIndex].activityGroup !== "Meal") {
  //   //       let tempactTot = parseFloat(
  //   //         parseFloat(data[dataIndex].duration) + actTotal
  //   //       );
  //   //       if (!actArray.includes(dataIndex)) {
  //   //         actArray.push(dataIndex);
  //   //         setActivityDuration(tempactTot);
  //   //       }
  //   //     }

  //   //     if (data[dataIndex].activityGroup == "Meal") {
  //   //       let tempMealTot = parseFloat(
  //   //         parseFloat(data[dataIndex].duration) + mealTotal
  //   //       );
  //   //       if (!mealArray.includes(dataIndex)) {
  //   //         mealArray.push(dataIndex);
  //   //         setMealDuration(tempMealTot);
  //   //       }
  //   //     }

  //   //     if (!indexArray.includes(dataIndex)) {
  //   //       indexArray.push(dataIndex);
  //   //       setTotalDuration(tempTot);
  //   //     }

  //   //     if (!tripArray.includes(dataIndex)) {
  //   //       tripArray.push(dataIndex);
  //   //       setTripDuration(tempTripDurTot);
  //   //     }
  //   //     const DiffEndTripOutLocalTS = getDuration(
  //   //       data[dataIndex].endTripLocalTS,
  //   //       data[dataIndex].outLocalTS
  //   //     );
  //   //     //console.log(data[dataIndex].endTripLocalTS+" -  "+  data[dataIndex].outLocalTS+" sec= "+DiffEndTripOutLocalTS);
  //   //     if (
  //   //       parseInt(data[dataIndex].mileage) === AUTO_ADJUST_TRIP_MILEAGE &&
  //   //       data[dataIndex].inTrip === false &&
  //   //       parseInt(DiffEndTripOutLocalTS) === 0 &&
  //   //       parseInt(data[dataIndex].duration) === AUTO_CLOCK_OUT_TIME_DIFF
  //   //     ) {
  //   //       return {
  //   //         style: { backgroundColor: DURATION_GT_12 },
  //   //       };
  //   //     }
  //   //     // const { status, endDate, endTime, startDate, startTime } =
  //   //     //   data[dataIndex];
  //   //     // if (!(endDate && endTime && startDate && startTime)) {
  //   //     //   let applyColor =
  //   //     //     startDate &&
  //   //     //     moment().diff(moment(startDate, dateConfig.format3), "days") > 14
  //   //     //       ? bgOutOfRange
  //   //     //       : bgWithinRange;
  //   //     //   return {
  //   //     //     style: { backgroundColor: applyColor },
  //   //     //   };
  //   //     // }
  //   //   }
  //   //   return {};
  //   // },

  //   setTableProps: () => {
  //     setTotalDuration(0);
  //     setMealDuration(0);
  //     setActivityDuration(0);
  //     setTripDuration(0);
  //   },

  //   // rowsPerPage: defaultRowsPerPage,
  //   rowsPerPageOptions: defaultPaginationOptions,
  //   textLabels: getTextLabels(t),
  //   downloadOptions: { filename: "TransportDetails.csv" },
  //   customToolbarSelect: () => {},
  // };
  function replaceHistory(e) {
    if (e) {
      e.preventDefault();

      delete e.returnValue;
    }

    history.replace({ ...history.location, state: "" });
  }
  function getDuration(inLocalTS, outLocalTS) {
    let time = 0;
    try {
      if (
        inLocalTS &&
        inLocalTS !== "" &&
        inLocalTS !== "null" &&
        outLocalTS &&
        outLocalTS !== "" &&
        outLocalTS !== "null"
      ) {
        const end = moment(outLocalTS && outLocalTS.substr(0, 16));
        const start = moment(inLocalTS && inLocalTS.substr(0, 16));
        if (start.isValid() && end.isValid()) {
          const diff = moment.duration(end.diff(start));
          time = diff.asSeconds();
        }
      }
    } catch (error) {
      console.error("Error in duration calculation: ", error);
    }
    return time.toFixed(2);
  }
  const setTotalDuration = (val) => {
    Tot = val;
    if (totalDurationRef.current) {
      totalDurationRef.current.innerText = parseFloat(Tot).toFixed(2);
    }
  };
  const setActivityDuration = (val) => {
    actTotal = val;
    if (totalActivityRef.current) {
      totalActivityRef.current.innerText = parseFloat(actTotal).toFixed(2);
    }
  };

  const setMealDuration = (val) => {
    mealTotal = val;
    if (totalMealRef.current) {
      totalMealRef.current.innerText = parseFloat(mealTotal).toFixed(2);
    }
  };

  const setTripDuration = (val) => {
    tripTotal = val;
    if (totalTripDurationRef.current) {
      totalTripDurationRef.current.innerText = parseFloat(tripTotal).toFixed(2);
    }
  };
  const deleteTransportationDetails = (act) => {
    setDisableDeleteBtn(true);

    console.log("Delete activity group=====", act);
    const deletedPunches = act.map((punch) => {
      let punchData = {
        punchId: punch.punchId,
        tripDeleted: true,
        inTrip: false,
        startTripLocalTS: punch.startTripLocalTS ? punch.startTripLocalTS : "",
        endTripLocalTS: punch.endTripLocalTS ? punch.endTripLocalTS : "",
      };
      if (punch.inTrip && punch.inTrip === true && !punch.outLocalTS) {
        if (punch?.startTripLocalTS) {
          punchData.startTripLocalTS = punch.startTripLocalTS;
          punchData.endTripLocalTS = moment(punch.startTripLocalTS)
            .add(1, "minutes")
            .format(dateConfig.format4);
        }
        if (punch?.startTripTS) {
          punchData.endTripTS = moment(punch.startTripTS)
            .add(1, "minutes")
            .toISOString();
        }
        if (punch?.startOdometer) {
          punchData.endOdometer = (
            parseInt(punch.startOdometer) + 1
          ).toString();
        }
        punchData.mileage = AUTO_ADJUST_TRIP_MILEAGE;
        punchData.actionTS = new Date().toISOString();
      }
      return punchData;
    });
    deleteTripPunch(deletedPunches)
      .then((result) => {
        setDisableDeleteBtn(true);
        setSelectedTransDetails([]);
        setConfirmDialogDel({ ...confirmDialogDel, isOpen: false });
        if (result) {
          setConfirmationBox({ ...confirmationBox, isOpen: true });
        }
      })
      .catch((error) => {
        setDisableDeleteBtn(false);
        setConfirmDialogDel({ ...confirmDialogDel, isOpen: false });
        console.log(error);
      });
  };
  const deleteDone = () => {
    setConfirmationBox({ ...confirmationBox, isOpen: false });
    table.resetRowSelection();
  };

  const handleTransDelete = (selectedRows) => {
    if (selectedRows.length > 0) {
      setConfirmDialogDel({
        title: "other.tlConfirmation",
        subTitle: t("pgReview.deleteWorkersDialog.subTitle") + " ?",
        isOpen: true,
        onConfirm: () => {
          deleteTransportationDetails(selectedRows);
        },
      });
    }
  };

  const table = useMaterialReactTable({
    columns,
    data: data,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: isLoading,
      showProgressBars: isLoading
    },
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition:'none'
        }
      },
      variant: 'determinate'
    },
    muiSkeletonProps:{
      animation:'wave',
      height: 20
    },
    enableSelectAll: true,
    enablePagination: true,
    enableGrouping: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    enableRowSelection: true,
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true,
    },
    initialState: {
      density: "compact",
      pagination: {
        pageSize: 50,
      },
    },
    muiTableContainerProps: {
      sx: {
        minHeight: `calc(100vh - 400px)`,
        maxHeight: `calc(100vh - 220px)`,
      },
    },
    muiTableHeadCellProps: {
      align: "left",
    },
    muiTableBodyCellProps: {
      align: "left",
    },
    muiTableBodyRowProps:({row})=>{
      let dataIndex = row.index;
      const bgWithinRange = INCOMPLETE_BG_VALID;
      const bgOutOfRange = INCOMPLETE_BG_INVALID;
      if (data[dataIndex]) {
        let tempTot = parseFloat(parseFloat(data[dataIndex].duration) + Tot);
        let tempTripDurTot = data[dataIndex].tripDuration
          ? parseFloat(parseFloat(data[dataIndex].tripDuration) + tripTotal)
          : tripTotal;
        if (data[dataIndex].activityGroup !== "Meal") {
          let tempactTot = parseFloat(
            parseFloat(data[dataIndex].duration) + actTotal
          );
          if (!actArray.includes(dataIndex)) {
            actArray.push(dataIndex);
            setActivityDuration(tempactTot);
          }
        }

        if (data[dataIndex].activityGroup == "Meal") {
          let tempMealTot = parseFloat(
            parseFloat(data[dataIndex].duration) + mealTotal
          );
          if (!mealArray.includes(dataIndex)) {
            mealArray.push(dataIndex);
            setMealDuration(tempMealTot);
          }
        }

        if (!indexArray.includes(dataIndex)) {
          indexArray.push(dataIndex);
          setTotalDuration(tempTot);
        }

        if (!tripArray.includes(dataIndex)) {
          tripArray.push(dataIndex);
          setTripDuration(tempTripDurTot);
        }
        const DiffEndTripOutLocalTS = getDuration(
          data[dataIndex].endTripLocalTS,
          data[dataIndex].outLocalTS
        );
        //console.log(data[dataIndex].endTripLocalTS+" -  "+  data[dataIndex].outLocalTS+" sec= "+DiffEndTripOutLocalTS);
        if (
          parseInt(data[dataIndex].mileage) === AUTO_ADJUST_TRIP_MILEAGE &&
          data[dataIndex].inTrip === false &&
          parseInt(DiffEndTripOutLocalTS) === 0 &&
          parseInt(data[dataIndex].duration) === AUTO_CLOCK_OUT_TIME_DIFF
        ) {
          return {
            style: { backgroundColor: DURATION_GT_12 },
          };
        }
      }
      return {};
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const handleDeleteWrap = () => {
        const selectedRows = table
          .getSelectedRowModel()
          .flatRows.map((row) => row.original);
        handleTransDelete(selectedRows);
      };
      return (
        <Grid
          container
          style={{
            gap: "20px",
            alignItems: "flex-end",
            margin: "5px 20px 0 20px",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" sx={{color: "#58595B"}}>
            {properCase(t("other.transportationDetails"))}
          </Typography>
          <Grid item style={{ display: "inline-flex", gap: "30px" }}>
          <span style={{cursor: "not-allowed"}}>
            <Button
              variant="outlined"
              onClick={handleDeleteWrap}
              disabled={!(table.getIsSomeRowsSelected() || table.getIsAllPageRowsSelected())}
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                borderRadius: "5px",
                lineHeight: "20px",
                borderColor:"#FF0000",
                color:"#FF0000",
                backgroundColor:"#ffffff",
                ':hover':{
                  backgroundColor: "#FF0000",
                  color:"#ffffff",
                  borderColor:"#ff0000"
                },
                '&.Mui-disabled':{
                  color: "rgba(244, 67, 54, 0.5)",
                  borderColor:"rgba(244, 67, 54, 0.5)"
                }
              }}
            >
              {properCase(t("pgReview.tableStaticText.btnDelete"))}
            </Button>
            </span>
            <ConfirmDialog
              confirmDialog={confirmDialogDel}
              setConfirmDialog={setConfirmDialogDel}
            />
            <Confirmation
              confirmationMsg={confirmationBox.isOpen}
              closeModalConfirmationMsg={deleteDone}
              confirmationMsgText={confirmationBox.subTitle}
              confirmationTitleText={confirmationBox.title}
            />
            {openEditModal && (
              <TransportDetailsModal
                open={openEditModal}
                onCancel={() => {
                  setOpenEditModal(false);
                  setSelectedTripPunch({});
                }}
                selectedTripPunch={selectedTripPunch}
                onSave={onSaveTripDetails}
                loggedInUser={user}
              />
            )}
            <Confirmation
              confirmationMsg={confirmationBox.isOpen}
              closeModalConfirmationMsg={updateDone}
              confirmationMsgText={confirmationBox.subTitle}
              confirmationTitleText={confirmationBox.title}
            />
          </Grid>
        </Grid>
      );
    },
  });

  return (
    <>
      <Grid container justify="space-between">
        <Grid item>
          <WeekPicker
            size="small"
            variant="outlined"
            weekChangeHandler={weekChangeHandler}
            startDate={startDate}
            renderInput={(params) => (
              <TextField
                {...params}
                label={properCase(t("pgHome.lblReportWeek"))}
                size="small"
                variant="outlined"
              />
            )}
            minDate={moment(new Date()).subtract(3, "months").startOf("month")}
            maxDate={moment(new Date()).add(1, "years")}
          />
        </Grid>
      </Grid>
      <Seperator />
      {/* {
      // isLoading ? (
      //   <>
      //     <CircularProgress />
      //     <Typography variant="body2">
      //       {t("pgReview.loadingGoogleUserDetails")}
      //     </Typography>
      //   </>
      // ) : 
      loadingError ? (
        <Alert severity="info">{t(loadingError)}</Alert>
      ) : null} */}

      {/* <div className={loadingError ? classes.hideElem : ""}> */}
        <MuiThemeProvider theme={TransportDetailsTheme}>
          {/* {!isLoading && <MaterialReactTable table={table} />}   */}
          <MaterialReactTable table={table} />
          <Card className={classes.container}>
            {/* <span className={classes.label1}>{properCase(t("other.tlactivityHours"))}</span>
            <span className={classes.label2} ref={totalActivityRef}></span> */}
            {/* <span className={classes.label1}>{properCase(t("other.tlmealHours"))}</span>
            <span className={classes.label2} ref={totalMealRef}></span> */}
            {/* <span className={classes.label1}>
              {properCase(t("pgReview.totalHours"))}
            </span>
            <span className={classes.label2} ref={totalDurationRef}></span> */}
            <span className={classes.label1}>
              {properCase(t("other.totalTripHours"))}
            </span>
            <span className={classes.label2}>{parseFloat(tripTotal).toFixed(2)}</span>
          </Card>
        </MuiThemeProvider>
        {/* <Button
                variant="contained"
                onClick={handleTransDelete}
                disabled={disableDeleteBtn}
                className={classes.delBtn}
              >
                {properCase(t("pgReview.tableStaticText.btnDelete"))}
              </Button>
            <ConfirmDialog
            confirmDialog={confirmDialogDel}
            setConfirmDialog={setConfirmDialogDel}
          />
          <Confirmation
            confirmationMsg={confirmationBox.isOpen}
            closeModalConfirmationMsg={deleteDone}
            confirmationMsgText={confirmationBox.subTitle}
            confirmationTitleText={confirmationBox.title}
          />
       {openEditModal && <TransportDetailsModal 
          open={openEditModal}
          onCancel = {() =>{
            setOpenEditModal(false);
            setSelectedTripPunch({});
          }}
          selectedTripPunch={selectedTripPunch}
          onSave = {onSaveTripDetails}
          loggedInUser = {user}
      />}
      <Confirmation
        confirmationMsg={confirmationBox.isOpen}
        closeModalConfirmationMsg={updateDone}
        confirmationMsgText={confirmationBox.subTitle}
        confirmationTitleText={confirmationBox.title}
      /> */}
      {/* </div> */}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  hideElem: {
    display: "none",
  },
  container: {
    marginTop: 10,
    background: "#1B75BC",
    color: "white",
    fontSize: 16,
    fontWeight: "bolder",
    minHeight: 40,
    width: "100%",
    lineHeight: 3,
  },
  label1: {
    marginLeft: 80,
  },
  label2: {
    marginLeft: 30,
    width: "100%",
  },
  button: {
    backgroundColor: theme.palette.primary.main,
  },
  delBtn: {
    color: "#FFFFFF",
    backgroundColor: "#f44336",
    ":disabled": {
      backgroundColor: "none",
    },
    "&:hover": {
      backgroundColor: "#58595B",
    },
  },
}));

export const ts = (time) => {
  return time
    ? moment(time).format(timeConfig.format4) +
        " " +
        moment(time).format(dateConfig.format5)
    : null;
};

TransportTripDetails.propTypes = {
  month: PropTypes.any.isRequired,
  week: PropTypes.any.isRequired,
  view: PropTypes.any.isRequired,
};
export default TransportTripDetails;
